<template>
  <b-card no-body>
    <b-overlay :show="loading" rounded="sm" variant="light">
      <b-card-header>
        <div>
          <b-card-title class="mb-1 d-flex rate">
            <div class="average-rate">
              <span>{{ rating }}%</span>
            </div>
            {{ $t("general.averageSatifiedRating") }}
          </b-card-title>
        </div>
      </b-card-header>

      <b-card-body>
        <chartjs-component-bar-chart
          :key="`starBarChart${key}`"
          :height="300"
          :data="chartjsData.starBarChart.data"
          :options="chartjsData.starBarChart.options"
        />
      </b-card-body>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCardSubTitle,
  BCardTitle,
  BButtonGroup,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import ChartjsComponentLineChart from "@/components/charts-components/ChartjsComponentLineChart.vue";
import ChartjsComponentBarChart from "@/components/charts-components/ChartjsComponentBarChart.vue";
import Ripple from "vue-ripple-directive";
import useJwt from "@/auth/jwt/useJwt";
import chartjsData from "./chartjsData";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardSubTitle,
    BCardTitle,
    BButtonGroup,
    BButton,
    BOverlay,
    ChartjsComponentLineChart,
    ChartjsComponentBarChart,
  },
  directives: {
    Ripple,
  },
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    rating: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      chartjsData,
      key: 1,
    };
  },
  computed: {
    currentLocale() {
      // console.log(this.chartData, this.rating);
      return this.$i18n.locale;
    },
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },
  watch: {
    currentLocale(value, oldValue) {
      if (oldValue && value && this.chartData?.data?.length) {
        this.mapChartData(this.chartData);
      }
    },
  },
  methods: {
    mapChartData(data) {
      const labels = data.labels.map((element) =>
        this.$tc("dashboard.star", element, { star: element })
      );
      this.chartjsData.starBarChart.data.labels = [...labels];
      this.chartjsData.starBarChart.data.datasets[0].data = [...data.data];
      this.chartjsData.starBarChart.data.datasets[0].label =
        this.$t("dashboard.rate");
      this.key++;
    },
  },
};
</script>
